import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { FaInstagram, FaFacebook } from "react-icons/fa";
import "../styles/Footer.css";

const translations = {
  ES: {
    phone: "Teléfono",
    email: "Email",
    followUs: "Síguenos en nuestras redes",
    legal: "Legales",
  },
  CAT: {
    phone: "Telèfon",
    email: "Correu electrònic",
    followUs: "Segueix-nos a les nostres xarxes",
    legal: "Legals",
  },
};

const Footer = () => {
  const { language } = useLanguage();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo y datos de contacto */}
        <div className="footer-left">
          <div className="footer-logo"></div>
          <div className="contact-info">
            <p>{translations[language].phone}: +34 662 461 236</p>
            <p>{translations[language].email}: info@gcemporda.com</p>
          </div>
        </div>

        {/* Redes Sociales */}
        <div className="footer-right">
          <div className="social-media">
            <p className="follow-text">{translations[language].followUs}</p>
            <div className="social-icons">
              <a
                href="https://www.instagram.com/grupoempordacreativo"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.facebook.com/grupoempordacreativo"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon facebook"
                aria-label="Facebook"
              >
                <FaFacebook />
              </a>
            </div>
          </div>

          {/* Link a Legales debajo de redes sociales */}
          <div className="footer-bottom">
            <a href="/legales" className="legal-link">
              {translations[language].legal}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
